const onsiteTypes = Object.freeze({
  ALERT: 0,
  POPUP: 1,
  INLINE: 2
})

const typeLabels = Object.freeze({
  0: 'CampaignForm_Onsite_Type_Alert',
  1: 'CampaignForm_Onsite_Type_Popup',
  2: 'CampaignForm_Onsite_Type_Inline'
})

export { onsiteTypes, typeLabels }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/OnsiteTypesEnum.js